import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import styles from "./styles/review.module.css";
import { Fit } from "./Fit";
import { resolveTargetProduct } from "./lib/resolve-target-product";
import { resolveCustomerName } from "./lib/resolve-customer-name";
import { resolveReviewTitle } from "./lib/resolve-review-title";
import { firstLetterUpper, formatSize } from "@lib/formatString";
import { useMobileDetect } from "@hooks/index";
import { Rating } from "../SingleView/Rating";

export function Review({ review }) {
  const { t } = useTranslation("reviews");
  if (!review) {
    return null;
  }

  if (!review.title && !review.body) {
    return null;
  }

  const target = resolveTargetProduct(review.target_title);
  const { firstName, lastName } = resolveCustomerName(review.customer);
  const title = resolveReviewTitle(review);
  const currentDevice = useMobileDetect();
  const isMobile = currentDevice.isMobile();

  return (
    <li className={styles.article}>
      {!isMobile && <Rating average={review.rating} />}
      <header className={styles.heading}>
        <p>{title ? firstLetterUpper(title) : firstLetterUpper(review.body)}</p>
        {isMobile && <span>{review.rating}/5</span>}
      </header>
      {title && <p>{review.body}</p>}
      {(firstName || lastName) && (
        <span>
          &#8212;{firstName} {lastName}
        </span>
      )}
      {target && (
        <dl className={styles.attributes}>
          <dt>{t("size-purchased")}:</dt>
          <dd>{formatSize(target.split(" / ")[1])}</dd>
        </dl>
      )}
      <Fit trait_ratings={review.trait_ratings} />
    </li>
  );
}

Review.propTypes = { review: PropTypes.object.isRequired };
